export enum ProctoringRuleType {
    FACE_NOT_DETECTED = 'FACE_NOT_DETECTED',
    MULTIPLE_FACES = 'MULTIPLE_FACES',
    EYES_CLOSED = 'EYES_CLOSED',
    LOOKING_AWAY = 'LOOKING_AWAY',
    HEAD_POSE_OUT_OF_RANGE = 'HEAD_POSE_OUT_OF_RANGE',
    FACE_TOO_FAR = 'FACE_TOO_FAR',
    MOBILE_PHONE_DETECTED = 'MOBILE_PHONE_DETECTED',
    EXTRA_PERSON_DETECTED = 'EXTRA_PERSON_DETECTED',
    VIRTUAL_CAMERA_DETECTED = 'VIRTUAL_CAMERA_DETECTED',
    BACKGROUND_NOISE = 'BACKGROUND_NOISE',
    MULTIPLE_VOICES = 'MULTIPLE_VOICES',
    VOICE_CHANGED = 'VOICE_CHANGED',
    MICROPHONE_DISABLED = 'MICROPHONE_DISABLED',
    CAMERA_DISABLED = 'CAMERA_DISABLED',
    TAB_SWITCH = 'TAB_SWITCH',
    WINDOW_MINIMIZE = 'WINDOW_MINIMIZE',
    WINDOW_BLUR = 'WINDOW_BLUR',
    SCREEN_CHANGE = 'SCREEN_CHANGE',
    SCREEN_SHARE_STOPPED = 'SCREEN_SHARE_STOPPED',
    FULLSCREEN_EXIT = 'FULLSCREEN_EXIT',
    SCREENSHOT_ATTEMPT = 'SCREENSHOT_ATTEMPT',
    BROWSER_REFRESH = 'BROWSER_REFRESH',
    DEVICE_CHANGE = 'DEVICE_CHANGE',
    NETWORK_DISCONNECT = 'NETWORK_DISCONNECT',
    VPN_DETECTION = 'VPN_DETECTION',
    REMOTE_DESKTOP_DETECTION = 'REMOTE_DESKTOP_DETECTION',
    CONTEXT_MENU_BLOCKED = 'CONTEXT_MENU_BLOCKED',
    COPY = 'COPY',
    PASTE = 'PASTE',
    DEVTOOLS_OPEN = 'DEVTOOLS_OPEN',
    FACE_EXPRESSION = 'FACE_EXPRESSION'
}

export const RULE_TYPE_MAP: Record<string, ProctoringRuleType> = {
    'Face Not Detected': ProctoringRuleType.FACE_NOT_DETECTED,
    'Multiple Faces Detected': ProctoringRuleType.MULTIPLE_FACES,
    'Eyes Closed': ProctoringRuleType.EYES_CLOSED,
    'Looking Away': ProctoringRuleType.LOOKING_AWAY,
    'Head Pose Out Of Range': ProctoringRuleType.HEAD_POSE_OUT_OF_RANGE,
    'Face Too Far': ProctoringRuleType.FACE_TOO_FAR,
    'Mobile Phone Detected': ProctoringRuleType.MOBILE_PHONE_DETECTED,
    'Extra Person Detected': ProctoringRuleType.EXTRA_PERSON_DETECTED,
    'Virtual Camera Detected': ProctoringRuleType.VIRTUAL_CAMERA_DETECTED,
    'Background Noise': ProctoringRuleType.BACKGROUND_NOISE,
    'Multiple Voices': ProctoringRuleType.MULTIPLE_VOICES,
    'Voice Changed': ProctoringRuleType.VOICE_CHANGED,
    'Microphone Disabled': ProctoringRuleType.MICROPHONE_DISABLED,
    'Camera Disabled': ProctoringRuleType.CAMERA_DISABLED,
    'Tab Switch': ProctoringRuleType.TAB_SWITCH,
    'Window Minimize': ProctoringRuleType.WINDOW_MINIMIZE,
    'Window Blur': ProctoringRuleType.WINDOW_BLUR,
    'Screen Change': ProctoringRuleType.SCREEN_CHANGE,
    'Screen Share Stopped': ProctoringRuleType.SCREEN_SHARE_STOPPED,
    'Fullscreen Exit': ProctoringRuleType.FULLSCREEN_EXIT,
    'Screenshot Attempt': ProctoringRuleType.SCREENSHOT_ATTEMPT,
    'Browser Refresh': ProctoringRuleType.BROWSER_REFRESH,
    'Device Change': ProctoringRuleType.DEVICE_CHANGE,
    'Network Disconnect': ProctoringRuleType.NETWORK_DISCONNECT,
    'VPN Detection': ProctoringRuleType.VPN_DETECTION,
    'Remote Desktop Detection': ProctoringRuleType.REMOTE_DESKTOP_DETECTION,
    'Context Menu Blocked': ProctoringRuleType.CONTEXT_MENU_BLOCKED,
    'Copy': ProctoringRuleType.COPY,
    'Paste': ProctoringRuleType.PASTE,
    'DevTools Open': ProctoringRuleType.DEVTOOLS_OPEN,
    'Face Expression': ProctoringRuleType.FACE_EXPRESSION
};